import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export interface GetDigitalAssetsDownloadParams {
  search?: string;
  officeCode?: string;
  recordIds?: string;
}

export const getDigitalAssetsDownload = async <T>(
  request: GetDigitalAssetsDownloadParams,
): Promise<T[]> => {
  const response = await axios.post<T[]>(
    `${API_BASE_URL}/GetDigitalAssetsDownload`,
    request,
  );

  return response.data;
};
